import AlertBannerPresentation from 'components/AlertBanner/AlertBannerPresentation'

export default {
  Presentation: AlertBannerPresentation,
}
